// extracted by mini-css-extract-plugin
export var container = "_7x-0";
export var error = "_7x-9";
export var label = "_7x-5";
export var light = "_7x-6";
export var md = "_7x-3";
export var sm = "_7x-2";
export var thin = "_7x-8";
export var thinBold = "_7x-7";
export var vertical = "_7x-4";
export var xs = "_7x-1";